export default "__VITE_ASSET__D45JFcBU__"